//封装接口
import { fetch, fetchJson, fetchSessionJson } from "../../utils/fetch";
import { roomJson } from "../roomJson.js";
import { layout } from "../../../static/js/layout.js";
//cc接口
export function location(data) {
  let commondata = {
    tag: null,
    cmd: "lookup",
    ver: "4.0",
    dev: "",
    devt: "web",
    os: navigator.userAgent.toLowerCase()
  };
  let paramsData = Object.assign(commondata, data);
  let params = {
    options: {
      url: "/login/location?cmd=lookup",
      method: "post",
      data: JSON.stringify(paramsData)
    }
  };
  return fetch(params);
}
//客户端登录
export function ulogin(data) {
  let commondata = {
    tag: "",
    cmd: "auth",
    ver: "4.0",
    dev: "web",
    devt: "web",
    os: navigator.userAgent.toLowerCase(),
    captcha: 85
  };
  let paramsData = Object.assign(commondata, data);
  let params = {
    options: {
      url: "/login/ulogin?cmd=auth",
      method: "post",
      data: JSON.stringify(paramsData)
    }
  };
  return fetch(params);
}
//获取用户信息
/***获取组织通讯录***/
//获取部门信息
export function department(data) {
  let commonData = {
    cmd: "get",
    obj: "department",
    tag: "",
    updatetime: 0,
    version: "",
    ver: "1.0.0",
    dev: "web",
    devt: "web",
    os: navigator.userAgent.toLowerCase()
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: "/resource/userdata?cmd=get&obj=department",
      method: "post",
      data: JSON.stringify(paramsData)
    }
  };
  return fetch(params);
}
//获取部门用户信息
export function departmentuser(data) {
  let commonData = {
    cmd: "get",
    obj: "department_user",
    tag: "",
    updatetime: 0,
    version: "",
    ver: "1.0.0",
    dev: "web",
    devt: "web",
    os: navigator.userAgent.toLowerCase()
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: "/resource/userdata?cmd=get&obj=department_user",
      method: "post",
      data: JSON.stringify(paramsData)
    }
  };
  return fetch(params);
}
//获取用户信息
export function user(data) {
  let commonData = {
    cmd: "get",
    obj: "user",
    tag: "",
    updatetime: 0,
    version: "",
    ver: "1.0.0",
    dev: "web",
    devt: "web",
    os: navigator.userAgent.toLowerCase()
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: "/resource/userdata?cmd=get&obj=user",
      method: "post",
      data: JSON.stringify(paramsData)
    }
  };
  return fetch(params);
}
//获取组织所有用户
export function orgcontacts(data) {
  let commonData = {
    cmd: "download",
    obj: "orgcontacts",
    tag: "",
    version: "",
    ver: "1.0.0",
    dev: "web",
    devt: "web",
    os: navigator.userAgent.toLowerCase()
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: "/resource/userdata?cmd=download&obj=orgcontacts",
      method: "post",
      data: JSON.stringify(paramsData)
    }
  };
  return fetch(params);
}
/*******appServer接口**********/
/*login authortze
   parameters data{Object}  about sid，cid，uid
     sid：session Id    Obtained from CC inference CC-login/ulogin?cmd=auth
     cid：company Id    Obtained from CC inference CC-login/ulogin?cmd=auth
     uid：user Id       Obtained from CC inference CC-login/ulogin?cmd=auth
   URL：/1.0/auth
   Method：post
   return：success：token  error：errorInfo
*/
export function accessToken(data) {
  let commonData = {
    tag: ""
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: "/1.0/auth",
      method: "post",
      data: JSON.stringify(paramsData)
    },
    headers: { "Content-Type": "application/json" }
  };
  return fetch(params);
}
/*@创建房间create room
 * parameters data{Object} about name（Require），room(Required)
 *   name:参会人姓名。从CC '/resource/userdata?cmd=get&obj=user'中获得
 *   room：设置房间信息，从../../static/js/roomJson.js获取，并修改
 *parameters header{Object} ，自定义header头部
 * URL：/1.0/rooms
 * method：post
 * return(返回)：success：roomId(会议室ID)  err：errorInfo
 * */
export function createRoom(data, header) {
  console.log(data);
  roomJson.room.name = data.name;
  let paramsData = {
    compere: data.compere,
    name: data.name,
    // room:roomJson.room,//room和password 二选一
    password: {
      host: "haha",
      participant: "xixi",
      visitor: ""
    },
    //预约会议7777不管用
    templt: 0
    // ctime:{   //预约会议使用
    //      time:JSON.parse(JSON.stringify((new Date()).getTime()).substr(0,10)),  // 第一次会议开始
    //      duration:7200,  // 会议时长，单位秒
    //      cycletype:2, // 会议周期类型：0：无，1：日，2：周，3：月
    //      nday:[4], // 周期会议时间数组  当cycletype = 0 / 1 忽略此值  当 cycletype = 2，此值表示周几，周一周二循环为[1, 2]  当 cycletype = 3，此值表示几号，1号9号为[1,9]
    //      topic:"Morning Meeting"
    // }
  };
  let params = {
    options: {
      url: "/1.0/rooms",
      method: "post",
      data: JSON.stringify(paramsData)
    },
    headers: header
  };
  return fetchJson(params);
}
/*
* get room info获取房间信息
* parameters： roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
* url：/1.0/rooms/${roomId}
*    说明：roomId：从创建房间接口返回roomId或者手动输入
* method：get
* return：success：roomInfo err：errorInfo
*录制相关返回   recordPermission    录制功能，0 此会议不允许录制，1允许录制
    recordStatus        录制状态，0无录制，1录制正在进行中
    recordDetails       录制详情，这是个数组，格式如下，显示本场会议所有录制记录。stop为0的项表示正在录制中。

    [
        {"id":"111111","start":1587624184,"stop":1587624197},
        {"id":"222222","start":1587624194,"stop":0},
        {"id":"333333","start":1587958645,"stop":1587958645}
    ]
* */
export function getRoomInfo(roomId) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}`,
      method: "get"
    },
    headers: { "Content-Type": "application/json" }
  };
  return fetchSessionJson(params);
}
/*
 *get Room token ：获取加入房间的Token
 * parameters
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * data{Object} ：about sid：登录后用户的sid，userName：用户名 ， passCode：会议角色相应的密码 （目前，仅针对游客）
 * 注意：登录后入会：参数为sid，userNama，passCode
 *       游客入会：参数为userName，passCode
 * header{Object}：自定义header头部
 * return：success：roomToken（String） sessionToken（String）  err：errorInfo
 * 说明：  roomToken： 用于加入owt会议
 *         sessionToken：用于通过appserver进行会中控制
 * */
export function joinRoom(roomId, data, header) {
  console.log(roomId);
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/token`,
      method: "post",
      data: data
    },
    headers: { "Content-Type": "application/json" }
  };
  return fetchJson(params);
}
/**
 * 加入混屏addMixStream
 * parameters:
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 *  streamId{String}：流Id
 *  data{Object} about：op
 * header{Object}：自定义header头部
 * URl：/1.0/rooms/${roomId}/streams/${streamId}
 * roomId:从创建房间接口返回
 * streamId：加入混屏的流ID,从owt，conference.join()方法中返回
 *return：success：successInfo err：errorInfo
 * */
export function addMixStream(roomId, streamId, data, header) {
  let commonData = {
    op: "mixStream"
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/streams/${streamId}`,
      method: "post",
      data: paramsData
    },
    headers: header
  };
  return fetchJson(params);
}
/**
 * 删除房间 delete Room
 * parameters：
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * header{Object}：自定义header头部
 * URL：/1.0/rooms/${roomId}
 *roomId：房间ID，从创建房间中返回或者参会者直接输入房间id得到
 *return：success：successsInfo err:errorInfo
 * */
export function deleteRoom(roomId, header) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}`,
      method: "delete"
    },
    headers: header
  };
  //怡言：改成fetchSessionJson
  return fetchSessionJson(params);
}
/**
 * 退出混屏addMixStream
 * parameters:
 *   roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 *  streamId{String}：流Id
 *  data{Object} about：op值为unmixStream
 * header{Object}：自定义header头部
 * URl：/1.0/rooms/${roomId}/streams/${streamId}
 * roomId:从创建房间接口返回
 * streamId：加入混屏的流ID,从owt，conference.join()方法中返回
 *return：success：successInfo err：errorInfo
 * */
export function unmixStream(roomId, streamId, data, header) {
  let commonData = {
    op: "unmixStream"
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/streams/${streamId}`,
      method: "post",
      data: paramsData
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/*设置视频、音频打开或者关闭
 * parameters：
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 *  streamId{String}：流Id
 *  data{Object} about  op:startAudio startVideo stopAudio stopVideo
 * header{Object}：自定义header头部
 * URl：/1.0/rooms/${roomId}/streams/${streamId}
 * roomId:从创建房间接口返回
 * streamId：加入混屏的流ID,从owt，conference.join()方法中返回
 *return：success：successInfo err：errorInfo
 * */
export function setDeviceInfos(roomId, streamId, data, header) {
  //op:startAudio startVideo stopAudio stopVideo
  let commonData = {
    op: ""
  };
  let paramsData = Object.assign(commonData, data);
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/streams/${streamId}`,
      method: "post",
      data: paramsData
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/**删除参会人（或请出会议）
 * parameters：
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * participantId{String}：参会者Id
 * header{Object}：自定义header头部
 * URL：/1.0/rooms/${roomId}/participants/${participantId}
 * roomId：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * participantId：参会者Id
 * return: success：successInfo err：errorInfo
 * **/
export function delParticipant(roomId, participantId, header) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/participants/${participantId}`,
      method: "delete"
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/*会议录制
** parameters：
   * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
   * streamId{String}：流Id
   * header{Object}：自定义header头部
 * URL：/1.0/rooms/${roomId}/recordings
   * roomId：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * return: success：id（录制Id） err：errorInfo
 *      errorInfo：
 *         1500    录制后台报错（OWT内部错误，找不到相应流id）
          1501    会议没开通录制功能
          1502    录制正在进行中，当前同时仅支持录制一个
          1503    客户录制空间用完啦
          1140    用户不是主持人也不是创建者，无权录制
* */
export function record(roomId, streamId, header) {
  let paramsData = {
    audio: `${streamId}-recording`,
    video: `${streamId}-recording`
  };
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/recordings`,
      method: "post",
      data: paramsData
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/*停止会议录制
 ** parameters：
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * recordingId{String}：从录制接口中获取
 * header{Object}：自定义header头部
 * URL：/1.0/rooms/${roomId}/recordings/${recordingId}
 * roomId：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * recordingId：从录制接口中获取
 * return: success：successInfo err：errorInfo
 * */
export function stopRecord(roomId, recordingId, header) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/recordings/${recordingId}`,
      method: "delete"
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/*获取所有流信息（暂时没有用到）
 * ** parameters：
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * header{Object}：自定义header头部
 * URL：/1.0/rooms/${roomId}/streams
 * roomId：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * return: success：successInfo err：errorInfo
 * */
export function getAllStreams(roomId, header) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/streams`,
      method: "get"
    },
    headers: header
  };
  return fetchSessionJson(params);
}
//指定参会人
export function assignAttendee(roomId, data, header) {
  let layoutData = [];
  data.curLayoutInfo.region.forEach(item => {
    //  	item.area.left = item.area.left.numerator == '0' && item.area.left.denominator == '0' ? '0' : `${item.area.left.numerator}/${item.area.left.denominator}`;
    //  	item.area.top = item.area.top.numerator == '0' && item.area.top.denominator == '0' ? '0' : `${item.area.top.numerator}/${item.area.top.denominator}`;
    //  	item.area.width = item.area.width.numerator == '0' && item.area.width.denominator == '0' ? '0' : `${item.area.width.numerator}/${item.area.width.denominator}`;
    //  	item.area.height = item.area.height.numerator == '0' && item.area.height.denominator == '0' ? '0' : `${item.area.height.numerator}/${item.area.height.denominator}`;
    if (data.settledStreams) {
      var settledStreamInfo = data.settledStreams.find(settledInfo => {
        return settledInfo.id == item.id;
      });
    }
    let pushData = { region: item };
    if (settledStreamInfo) {
      pushData = {
        region: item,
        settledStream: {
          user: settledStreamInfo.user,
          stream: settledStreamInfo.stream
        }
      };
    }
    layoutData.push(pushData);
  });
  let paramsData = {
    mixInfos: [
      {
        customLayout: layoutData,
        name: "common",
        manual: true,
        layoutid: data.layoutId,
        mixInterval: 0
      }
    ]
  };
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/status`,
      method: "post",
      data: JSON.stringify(paramsData)
    },
    headers: header
  };
  return fetchSessionJson(params);
}
//设置自动布局
export function setAutoRegion(roomId, header) {
  let paramsData = {
    mixInfos: [
      {
        name: "common",
        manual: false,
        mixInterval: 0
      }
    ]
  };
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/status`,
      method: "post",
      data: JSON.stringify(paramsData)
    },
    headers: header
  };
  return fetchSessionJson(params);
}
//设置轮询时间
export function setMixInterval(roomId, mixInterval, header) {
  let paramsData = {
    mixInfos: [
      {
        mixInterval: mixInterval,
        name: "common"
        // manual:data.manual
      }
    ]
  };
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/status`,
      method: "post",
      data: JSON.stringify(paramsData)
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/*
 * 获取房间的状态值：静音/非静音
 ** parameters：
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * header{Object}：自定义header头部
 * URL：/1.0/rooms/${roomId}/status
 * roomId：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * return: success：compere:userId  status:active/inactive err：errorInfo
 * **/

export function getRoomStatus(roomId, header) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/status`,
      method: "get"
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/**设置房间状态:静音inactive/非静音active、轮询时间
 ** parameters：
 * roomId{String} ：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * data {String} ：房间状态值为active/inactive
 * mixInterval{String}：轮询时间
 * header{Object}：自定义header头部
 * URL：/1.0/rooms/${roomId}/status
 * roomId：会议室ID：（1）创建房间入会，从创建创建房间接口返回（2）手动输入房间Id入会，roomId为输入Id
 * return: success：compere:userId  status:active/inactive err：errorInfo
 * **/
export function setRoomStatus(roomId, status, header) {
  //data:active（取消静音）  inactive（静音）
  let paramsData = {
    audio: status
  };
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/status`,
      method: "post",
      data: paramsData
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/**设置语音激励状态
 * parameters:
 *    roomId{String} ：会议室ID
 *    status{String} : 语音激励状态 值为："on" or "off"
 * */
export function setVoiceStatus(roomId, status, header) {
  let paramsData = {
    status: status
  };
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/voice/status`,
      method: "post",
      data: paramsData
    },
    headers: header
  };
  return fetchSessionJson(params);
}
/*获取房间语音激励状态
   response 
      {"status": "on" or "off"}
 * */
export function getVoiceStatus(roomId, header) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/voice/status`,
      method: "get"
    },
    headers: header
  };
  return fetchSessionJson(params);
}

/**
 * refreshsessiontoken *
 *  parameters
 *    roomId{String} ：会议室ID：
 * */
export function refreshsessiontoken(roomId) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/refreshsessiontoken`,
      method: "get"
    }
  };
  return fetchSessionJson(params);
}
export function getAllLayout(roomId) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/voice/layouts`,
      method: "get"
    }
  };
  return fetchSessionJson(params);
}
/**
 * 外呼pexip *
 *  parameters
 *     roomId{String} ：会议室ID：
 *     passcode{String} ：pexip密码
 * */
export function callPexip(roomId, passcode) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/pexip/call/passcode/${passcode}`,
      method: "post"
    }
  };
  return fetchSessionJson(params);
}
/**
 * 挂断pexip *
 *  parameters
 *     roomId{String} ：会议室ID：
 *     passcode{String} ：pexip密码
 * */
export function hangupPexip(roomId, passcode) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/pexip/call/passcode/${passcode}`,
      method: "delete"
    }
  };
  return fetchSessionJson(params);
}
/**
 * 获取pexip短链接 *
 *  parameters
 *     roomId{String} ：会议室ID：
 *     passcode{String} ：pexip密码
 * */
export function getPexipShortUrl(roomId, passcode) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/pexip/shorturl/passcode/${passcode}`,
      method: "get"
    }
  };
  return fetchSessionJson(params);
}
/**
 * 获取pexip角色*
 *  parameters
 *     roomId{String} ：会议室ID：
 *     passcode{String} ：pexip密码
 * */
export function getPexipRole(roomId, passcode) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/pexip/role/passcode/${passcode}`,
      method: "get"
    }
  };
  return fetchSessionJson(params);
}
/**
 * 更新转发到pexip流*
 *  parameters
 *     roomId{String} ：会议室ID：
 *     stream{String} ：stream
 * */
export function updateStreamToPexip(roomId, stream) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/pexip/update-stream`,
      method: "post",
      data: { stream }
    }
  };
  return fetchSessionJson(params);
}
/**
 *  通知拉流到会中
 *  parameters
 *     roomId{String} ：会议室ID：
 *     data{Object} : {
            "url": "rtmp://xxxxxx/live/cctv",    // 必选
            "audio": "true",    // 可选
            "video": "false"    // 可选
        }
 * */
export function pullStreamToMeet(roomId, data) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/streaming-ins`,
      method: "post",
      data: data
    }
  };
  return fetchSessionJson(params);
}
/**
 *  停止拉流到会中
 *  parameters
 *     roomId{String} ：会议室ID：
 *     data{Object} : {
            "url": "rtmp://xxxxxx/live/cctv",    // 必选
            "audio": "true",    // 可选
            "video": "false"    // 可选
        }
 * */
export function StopPullStreamToMeet(roomId) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/streaming-ins`,
      method: "delete"
    }
  };
  return fetchSessionJson(params);
}

// inter-cut
export function getInterCutDetail(roomId) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/streaming-ins`,
      method: "get"
    }
  };
  return fetchSessionJson(params);
}
// 获取当前用户身份： role  0代表非主持人，1代表主持人
export function getCurUserRole(roomId, data) {
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/role/cid/${data.cid}/uid/${data.uid}`,
      method: "get"
    }
  };
  console.log(params);
  return fetch(params);
}

// sip外呼
export function sipCalls(roomId,data){
  let params = {
    options: {
      url: `/1.0/rooms/${roomId}/sipcalls`,
      method: "post",
      data: data
    }
  };
  return fetchSessionJson(params);
}